import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import AccionMejora from "./AccionMejora";
import Swal from "sweetalert2";

const cookie = new Cookies();

const OmSolucionadas = ({ institucionId }) => {
  const tipoUsuario = Number(cookie.get("tipo_Usuario"));
  const institucionCookie = cookie.get("institucionid");

  const [instituciones, setInstituciones] = useState([]);
  const [institucionSeleccionada, setInstitucionSeleccionada] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // 🔹 VER MÁS / VER MENOS
  const [expandedRows, setExpandedRows] = useState({});

  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // 🔹 CONTROL DE ROLES
  const puedeVerInstituciones = [1, 4, 6].includes(tipoUsuario);

  /* ================================
     🔹 CARGAR INSTITUCIONES
  ==================================*/
  useEffect(() => {
    if (puedeVerInstituciones) {
      const fetchInstituciones = async () => {
        try {
          const res = await axios.get(
            "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
          );
          setInstituciones(res.data || []);
        } catch (error) {
          console.error("Error cargando instituciones:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudieron cargar las instituciones",
          });
        }
      };
      fetchInstituciones();
    }
  }, [tipoUsuario]);

  /* ================================
     🔹 FUNCIÓN BUSCAR
  ==================================*/
  const handleBuscar = async () => {
    try {
      const idParametro = puedeVerInstituciones
        ? institucionSeleccionada
        : institucionId || institucionCookie;

      if (!idParametro) {
        Swal.fire({
          icon: "warning",
          title: "Atención",
          text: "Debe seleccionar una institución",
        });
        return;
      }

      setLoading(true);

      const { data } = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerOmSolucionadasPorInstitucionId/${idParametro}`,
      );

      setData(data || []);
      setCurrentPage(1);
      setExpandedRows({}); // 🔹 reset de expansión al buscar

      if (!data || data.length === 0) {
        Swal.fire({
          icon: "info",
          title: "Sin resultados",
          text: "No se encontraron registros para esta institución",
        });
      }
    } catch (error) {
      console.error("Error cargando OM solucionadas:", error);

      if (error.response) {
        Swal.fire({
          icon: "error",
          title: "Error del servidor",
          text:
            error.response.data?.message || "Error al consultar la información",
        });
      } else if (error.request) {
        Swal.fire({
          icon: "error",
          title: "Sin conexión",
          text: "No se pudo conectar con el servidor",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error inesperado",
          text: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  /* ================================
     🔹 CARGA AUTOMÁTICA
  ==================================*/
  useEffect(() => {
    if (!puedeVerInstituciones) {
      handleBuscar();
    }
  }, []);

  /* ================================
     🔹 PAGINACIÓN
  ==================================*/
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Oportunidades Solucionadas
          </h6>
        </div>

        <div className="card-body">
          {/* 🔹 FILTRO POR INSTITUCIÓN */}
          {puedeVerInstituciones && (
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <select
                value={institucionSeleccionada}
                onChange={(e) => setInstitucionSeleccionada(e.target.value)}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  minWidth: "250px",
                }}
              >
                <option value="">-- Seleccione institución --</option>
                {instituciones.map((inst) => (
                  <option key={inst.id} value={inst.id}>
                    {inst.razon_Social}
                  </option>
                ))}
              </select>

              <button
                onClick={handleBuscar}
                disabled={loading}
                style={{
                  background: "#1976d2",
                  color: "white",
                  border: "none",
                  padding: "7px 15px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? "Buscando..." : "Buscar"}
              </button>
            </div>
          )}

          {loading ? (
            <p style={{ textAlign: "center" }}>Cargando información...</p>
          ) : (
            <>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>ID</th>
                    <th style={thStyle}>INSTITUCIÓN</th>
                    <th style={thStyle}>ORIGEN</th>
                    <th style={thStyle}>ESTADO</th>
                    <th style={thStyle}>DESCRIPCIÓN</th>
                    <th style={thStyle}>GESTIÓN</th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.length === 0 ? (
                    <tr>
                      <td colSpan="6" style={emptyStyle}>
                        No hay OM solucionadas
                      </td>
                    </tr>
                  ) : (
                    currentItems.map((item) => (
                      <tr key={item.id}>
                        <td style={tdStyle}>{item.id}</td>
                        <td style={tdStyle}>{item.nombreInstitucion || "-"}</td>
                        <td style={tdStyle}>{item.origen || "-"}</td>
                        <td style={tdStyle}>
                          <span style={estadoStyle}>
                            {item.estadoOportunidad?.toUpperCase()}
                          </span>
                        </td>

                        {/* 🔹 DESCRIPCIÓN CON VER MÁS / MENOS */}
                        <td style={tdStyle}>
                          {item.descripcion ? (
                            <>
                              {expandedRows[item.id]
                                ? item.descripcion
                                : item.descripcion.substring(0, 80) +
                                  (item.descripcion.length > 80 ? "..." : "")}

                              {item.descripcion.length > 80 && (
                                <span
                                  onClick={() => toggleExpand(item.id)}
                                  style={{
                                    color: "#1976d2",
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {expandedRows[item.id]
                                    ? "Ver menos"
                                    : "Ver más"}
                                </span>
                              )}
                            </>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td style={tdStyle}>
                          <AccionMejora
                            idOm={item.id}
                            estado={item.estadoOportunidad}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* 🔹 PAGINACIÓN */}
              {totalPages > 1 && (
                <div style={paginationContainer}>
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={paginationButton}
                  >
                    Anterior
                  </button>

                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      onClick={() => paginate(index + 1)}
                      style={{
                        ...paginationButton,
                        background:
                          currentPage === index + 1 ? "#1976d2" : "#f1f1f1",
                        color: currentPage === index + 1 ? "white" : "#333",
                      }}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={paginationButton}
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const thStyle = {
  padding: "10px",
  fontSize: "13px",
  color: "#555",
  borderBottom: "2px solid #eee",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
  borderBottom: "1px solid #eee",
};

const estadoStyle = {
  background: "#e8f5e9",
  color: "#2e7d32",
  padding: "4px 10px",
  borderRadius: "12px",
  fontSize: "12px",
  fontWeight: "600",
};

const emptyStyle = {
  textAlign: "center",
  padding: "20px",
  color: "#888",
};

const paginationContainer = {
  marginTop: "20px",
  display: "flex",
  justifyContent: "center",
  gap: "5px",
  flexWrap: "wrap",
};

const paginationButton = {
  padding: "6px 12px",
  border: "1px solid #ccc",
  borderRadius: "5px",
  cursor: "pointer",
};

export default OmSolucionadas;
